export default __webpack_public_path__ + "static/SR USA - Sulfites - Statement-3044d916489b86ff64eeb6236f2e1a17.pdf";